import React, {Component} from 'react';
// import {Link} from "react-router-dom";
import {formReceivedUserInput, privacyAcceptChanged, submitRegistration} from "../Actions";
import {Button, Checkbox, Divider, Form, Header, Message, Modal} from "semantic-ui-react";

export default class Register extends Component {
    submitForm(e) {
        e.preventDefault();
        submitRegistration(this.props.email, this.props.password, this.props.company);
    }

    render() {
        return (
            <Modal
                size='small'
                open={true}>
                <Modal.Header>Register</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Header.Subheader>Create an account to get access to your personal API key and start making requests to our endpoints</Header.Subheader>
                    </Modal.Description>
                    <Divider/>
                    <Form onSubmit={this.submitForm.bind(this)}
                          error={!!this.props.formErrorMessage}
                          success={!!this.props.formInfoMessage}
                          loading={this.props.formDisabled}>
                        <Form.Input label='Email' name='email' value={this.props.email}
                                    onChange={formReceivedUserInput}/>
                        <Form.Input type='password' label='Password' name='password' autoComplete='false'
                                    value={this.props.password} onChange={formReceivedUserInput}/>
                        <Form.Input label='Company' name='company' placeholder='Optional' value={this.props.company}
                                    onChange={formReceivedUserInput}/>
                        <Form.Field>
                            <Checkbox name='privacy' checked={this.props.privacyAccepted}
                                      onChange={privacyAcceptChanged} label={<label>I agree to the <a
                                href="https://www.envimation.com/PrivacyPolicy.html" target="_blank">Privacy Policy</a></label>}/>
                        </Form.Field>

                        <Message error content={this.props.formErrorMessage}/>
                        <Message success content={this.props.formInfoMessage}/>
                        {/*<p>Already have an account? Sign in <Link to="#"*/}
                        {/*onClick={this.props.onLoginOpen}>here</Link>.*/}
                        {/*</p>*/}
                        <Modal.Actions style={{textAlign: 'right'}}>
                            <Button primary type='submit' disabled={!this.props.privacyAccepted}>Register</Button>
                        </Modal.Actions>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }

}




/** WEBPACK FOOTER **
 ** ./src/shared_states/SubscriptionRequest/components/Register.js
 **/